import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/patientSlice";

import patientApis from "src/api/patient";

import { common } from "src/types/index";
import { constants } from "src/constants/common";
import { handleApiRequest } from "../sagaHelper";

// get patient list saga
const GetPatientListSaga = function* GetPatientListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      patientApis.getPatientList,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getPatientListSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getPatientListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// add patient saga
const AddPatientSaga = function* AddPatientSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      patientApis.addPatient,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.addPatientSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.addPatientError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// delete Patient record saga

const DeletePatientRecordSaga = function* DeletePatientRecordSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      patientApis.deleteRecord,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.deletePatientRecordSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.deletePatientRecordError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// add patient plan saga
const AddPatientPlanSaga = function* AddPatientPlanSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  yield handleApiRequest({
    api: patientApis.addPatientPlan,
    payload,
    successAction: actions.addPatientPlanSuccess,
    errorAction: actions.addPatientPlanError,
    resolve,
    reject,
  });
};

// Get Query List
function* GetPatientQueryListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      patientApis.getQueryList,
      payload
    );

    if (Number(response.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response.code) === 0) {
      throw new Error(response.message);
    }

    yield put(actions.getPatientQueryListSuccess(response?.data as any));
    resolve?.(response);
  } catch (error) {
    yield put(
      actions.getPatientQueryListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject?.(error);
  }
}

function* SendPatientQuerySaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      patientApis.sendQuery,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }

    yield put(actions.sendPatientQuerySuccess(response?.data));
    resolve?.(response);
  } catch (error) {
    yield put(
      actions.sendPatientQueryError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject?.(error);
  }
}

export default function* patientSaga() {
  yield all([
    takeEvery(actions.getPatientListRequest, GetPatientListSaga),
    takeEvery(actions.addPatientRequest, AddPatientSaga),
    takeEvery(actions.deletePatientRecordRequest, DeletePatientRecordSaga),
    takeEvery(actions.addPatientPlanRequest, AddPatientPlanSaga),
    takeEvery(actions.getPatientQueryListRequest, GetPatientQueryListSaga),
    takeEvery(actions.sendPatientQueryRequest, SendPatientQuerySaga),
  ]);
}
